<template>
  <Component
    :is="maxSmall ? Drawer : Dropdown"
    :title="title"
    background="white"
  >
    <Tooltip :title="tooltip" :disabled="!tooltip || maxSmall">
      <slot />
    </Tooltip>
    <template #content>
      <div
        :class="{
          'w-full flex flex-col grow overflow-y-auto': maxSmall,
        }"
      >
        <Component
          :is="maxSmall ? DrawerClose : 'div'"
          as="div"
          :class="{
            'w-full flex flex-col p-4 gap-2': maxSmall,
          }"
        >
          <Component
            :is="maxSmall ? ButtonList : DropdownItemList"
            :items="items"
            :size="maxSmall ? 'xl' : 'lg'"
            @click="$emit('click', $event)"
          />
        </Component>
      </div>
    </template>
  </Component>
</template>

<script setup>
import { ButtonList } from "@/SharedComponents/ButtonList";
import { Drawer, DrawerClose } from "@/SharedComponents/Drawer";
import { Dropdown, DropdownItemList } from "@/SharedComponents/Dropdown";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["click"]);

defineProps({
  title: { type: String, required: true },
  tooltip: { type: String, required: false },
  items: { type: Array, required: true },
});
</script>
